import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import EthosGraphQLReaderForm from '../forms/ethos-graphql-reader-form';
import { ethosGraphQLReaderValidationSchema } from '../schema/ethosGraphQLReader.js';

export default function EthosGraphQLReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Ethos GraphQL Reader Node Details',
        altText: 'Ethos GraphQL Reader Node',
        defaultLabel: 'Ethos GraphQL Reader Node',
      }}
    >
      <CommonNode
        FormComponent={EthosGraphQLReaderForm}
        schemaResolver={ethosGraphQLReaderValidationSchema}
      />
    </NodeProvider>
  );
}
